export default {
  name: 'BasicInfo',

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('fleet/vehicle/basic_info_tab.tab_label'),
        key: 'basicInfo',
        validationErrors: this.validationErrors,
        tabContent: [
          {
            title: this.$t('fleet/vehicle/basic_info_tab.tab_label'),
            component: this.columnsContentComponent,
            rows: [
              {
                columnsCount: 2,
                images: {
                  count: 6,
                  perRowCount: 3,
                  keys: ['images']
                },
                fields: [
                  {
                    key: 'garage_number',
                    label: this.$t('fleet/vehicle_attribute.garage_number'),
                    type: 'text',
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'registration',
                    label: this.$t('fleet/vehicle.registration'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'label',
                    label: this.$t('fleet/vehicle.label'),
                    type: 'text',
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('fleet/vehicle.type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/types'
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'color_id',
                    label: this.$t('fleet/vehicle.color'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/colors'
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'group_id',
                    label: this.$t('fleet/vehicle.group'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'groups/autocomplete'
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'assigned_to_id',
                    label: this.$t('fleet/vehicle.driver'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'people/autocomplete'
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'tags',
                    label: this.$t('fleet.vehicle_tags'),
                    type: 'combobox',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicle-tags/autocomplete',
                      allowCustomValue: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'battery_voltage',
                    label: this.$t('fleet/vehicle_attribute.battery_voltage'),
                    field_type: 'number',
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'tracker_id',
                    label: this.$t('fleet/vehicle.tracker'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'tracker/autocomplete'
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'installation_location',
                    label: this.$t('fleet/vehicle_attribute.installation_location'),
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    // Marks the vehicle as one the winter service dispatches. Its own
                    // configuration is set up afterwards, on the vehicle's winter service
                    // tab - there is no record to hang it on until the vehicle exists.
                    key: 'is_winter_service',
                    type: 'base-switch',
                    label: this.$t('fleet/vehicle.is_winter_service'),
                    creatable: true,
                    visible: true,
                    editable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
